import React from 'react'

import Logo from 'common/Logo'
import Link from 'views/Global/Header/link'

export default props => (
  <footer className='bg-black w-100 pv4 ph3 ph5-l'>
    <div className='mw-page center white'>
      <div className='flex flex-column flex-row-l items-center'>
        <div className='mb4 mb0-l mr4-l'>
          <Logo.Medium />
          <Logo.Small />
        </div>
        <nav className='flex-l tc tl-l'>
          <Link className='db h-100 mb3 mb0-l mr4-l white' to='/'>Welcome</Link>
          <Link className='db h-100 mb3 mb0-l mr4-l white' to='/departments'>Departments</Link>
          <Link className='db h-100 lh-solid white' to='/locations'>Locations</Link>
        </nav>
      </div>
      <div className='w-100 mt4 mb3 bg-white-70'
        style={{
          height: '1px',
        }}
      />
      <div>
        <p className='tc tl-l norms-12'>© {(new Date()).getFullYear()} StyleTheory Private Limited. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
)
